import styled from '@emotion/styled';
import { teal } from 'Styles/colors';

export const StyledSingleSelectQuestion = styled.div`
  .hidden-radio {
    opacity: 0;
    position: absolute;
    pointer-events: none;
    width: 0;
    height: 0;
  }

  .button-like-label {
    position: relative;
    cursor: pointer;
    width: 100%;
    margin-bottom: 0.75rem;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    display: flex;
    justify-content: center;
    margin-left: 0;
    margin-right: 0;
  }

  .button-like-label:hover {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  .button-like-label .MuiFormControlLabel-label {
    width: 100%;
    font-weight: 400;
    color: #333;
    text-align: center;
  }

  /* Style for the selected option */
  .Mui-checked + .MuiFormControlLabel-label {
    font-weight: 600;
    color: ${teal._900};
  }

  input[type='radio']:checked + .MuiFormControlLabel-label,
  .Mui-checked.button-like-label {
    background-color: rgba(255, 255, 255, 1);
    border: 2px solid ${teal._400};
    font-weight: 600;
  }
`;
